import {combineEpics} from 'redux-observable'
import {epic as request} from 'request'
import {epic as storage} from './storage/epic'

export const rootEpic = combineEpics(
  request,
  storage,
)
